import {
  CompanyAPIRawRequestBodyType,
  CompanyAPIRequestBodyType
} from '../../types/company/api-request-body';

export const CompanyAPIRequestBody = ({
  koumutenId,
  name
}: CompanyAPIRequestBodyType): CompanyAPIRawRequestBodyType => ({
  construction_company_id: koumutenId,
  name
});

export const CompanyAPIRequestBodyPartial = ({
  koumutenId: constructionCompanyId,
  name
}: Partial<
  CompanyAPIRequestBodyType
>): Partial<CompanyAPIRawRequestBodyType> => ({
  construction_company_id: constructionCompanyId,
  name
});
